import React from 'react';

export const PrefixField = ({ children }) => {
  return <div className={'prefix'}>{children}</div>;
};

export const SuffixField = ({ children }) => {
  return <div className={'suffix'}>{children}</div>;
};
